/* @flow strict */

import * as React from 'react';
import { Link } from 'react-router-dom';

type PropsType = {
    handleClose: () => void
};

const Links = ({ handleClose }: PropsType): React.Element<'form'> => {
    return (
        <>
            <header>
                <h1>Your settings are saved!</h1>
                <h4 className="sub-header">
                    Create your first event, edit your settings, or learn more.
                </h4>
            </header>
            <form className='sparxo-manage-cards'>
                <Link to="/settings/account" replace onClick={(): void => handleClose()}>
                    <div className='sparxo-manage-card'>
                        <i className="img img-view-settings" />
                        <span>View Settings</span>
                    </div>
                </Link>
                <Link to="/events/new" replace onClick={(): void => handleClose()}>
                    <div className='sparxo-manage-card'>
                        <i className="img img-create-event" />
                        <span>Create Event</span>
                    </div>
                </Link>
                <a href="https://www.sparxo.com/knowledge-base/" onClick={(): void => handleClose()}>
                    <div className='sparxo-manage-card'>
                        <i className="img img-knowledge-base" />
                        <span>Knowledge Base</span>
                    </div>
                </a>

            </form>
        </>
    );
};

export default Links;
